import { Component, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

import { AuthenticationService } from '../shared/authentication.service';
import { CartService } from '../cart/cart.service';
import { CiprsRole } from '../shared/user';
import { environment } from './../../environments/environment';
import { InternalExternalInterceptor } from '../shared/internal-external-interceptor';
import { PublicAccessTerminalService } from '../shared/public-access-terminal.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.less']
})
export class LandingComponent {

  private tellMeMoreTemplateRef: BsModalRef;

  constructor(private authenticationService: AuthenticationService,
              private cartService: CartService,
              private modalService: BsModalService,
              private publicAccessTerminalService: PublicAccessTerminalService) { }

  isUserLoggedIn(): boolean {
    return this.authenticationService.isUserLoggedIn();
  }

  showCivilData(): boolean {
    const isBeingAccessedInternally = !InternalExternalInterceptor.isExternal();
    const isAllowedByRole = this.authenticationService.isUserInRoles(CiprsRole.Public);
    const isPat = this.publicAccessTerminalService.isPublicAccessTerminal(); // This rule is for pilot-only

    //return isBeingAccessedInternally && isAllowedByRole && isPat;
    return false; // never display Civil Data
  }

  showCriminalData(): boolean {
    const isBeingAccessedInternally = !InternalExternalInterceptor.isExternal();
    const isAllowedByRole =
      this.authenticationService.isUserInRoles(CiprsRole.District_Attorney, CiprsRole.Public, CiprsRole.Public_Defender);

    return isBeingAccessedInternally && isAllowedByRole;
  }

  showJuvenileData(): boolean {
    return this.authenticationService.isUserInRoles(CiprsRole.Defense_Attorney, CiprsRole.District_Attorney, CiprsRole.Public_Defender);
  }

  goToCriminalCiprs() {
    if (this.cartService.isEmpty()) {
      this.navigateToAngularCriminalApplication();
    } else {
      this.cartService.canCartBeAbandoned().then((value) => {
        if (value) {
          this.navigateToAngularCriminalApplication();
        }
      });
    }
  }

  private navigateToAngularCriminalApplication(): void {
    window.location.assign(environment.criminalApplicationUrl + '#/fromV2');
  }

  openTellMeMore(template: TemplateRef<any>): void {
    this.tellMeMoreTemplateRef = this.modalService.show(template, {class: 'modal-lg'});
  }
  closeTellMeMore() {
    this.tellMeMoreTemplateRef.hide();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/landing/landing.component.ts